import PeopleIcon from '@material-ui/icons/People';
import PersonAdd from '@material-ui/icons/PersonAdd';
import { CalendarToday, ExitToApp, LockOpen, Settings } from '@material-ui/icons';
import FeedbackIcon from '@material-ui/icons/Feedback';
import {
	HospitalInteractiveRoles,
	OfficeInteractiveRoles,
	OfficeManagerRoles
} from '@interfaces/UserProfile/UserRoleEnum';
import usePreferredUnits from '@components/UnitCalendarPage/utilities/usePreferredUnits';
import unitHasOpenTimeConfig from '@components/UnitCalendarPage/utilities/unitHasOpenTimeConfig';
import { useHistory } from 'react-router-dom';
import { useInteractiveLogout } from '@utilities/hooks/useInteractiveLogout/useInteractiveLogout';
import React from 'react';
import {
	UsePreferencesMenuReturnType
} from '@components/HeaderSection/NavigationOptions/PreferencesMenu/utilities/UsePreferencesMenuConfigReturnType';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';

const usePreferencesMenuConfig: () => UsePreferencesMenuReturnType = () => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const hasPrefUnitsWithOpenTimeConfig =
		usePreferredUnits(unitHasOpenTimeConfig).list.length > 0;
	const { ssmShowReleaseBlock20241205 } = useSsmUiFlags()


	const history = useHistory();

	const changeRoute = React.useCallback((path: string) => {
		history.push(path);
		setAnchorEl(null);
	}, [history]);

	const logout = useInteractiveLogout();

	const options = React.useMemo(() => [
		{
			id: 'accountSettings',
			label: 'Account settings',
			icon: Settings,
			onClick: () => changeRoute('/accountSettings/myInformation'),
		}, {
			id: 'orBlockReleaseReview',
			label: 'Block Release',
			icon: LockOpen,
			showForRoles: HospitalInteractiveRoles,
			onClick: () => changeRoute(ROUTE_CONSTANTS.BLOCK_RELEASE_REVIEW),
			shouldHide: !ssmShowReleaseBlock20241205,
		}, {
			id: 'officeBlockReleaseRequest',
			label: 'Block Release',
			icon: LockOpen,
			showForRoles: OfficeInteractiveRoles,
			onClick: () => changeRoute(ROUTE_CONSTANTS.BLOCK_RELEASE_RECOMMENDATION_LIST),
		}, {
			id: 'sendFeedback',
			label: 'Send us feedback',
			icon: FeedbackIcon,
			onClick: () => setAnchorEl(null),
		}, {
			id: 'orAvailabilityCalendar',
			label: 'OR availability calendar',
			icon: CalendarToday,
			showForRoles: HospitalInteractiveRoles,
			shouldHide: !hasPrefUnitsWithOpenTimeConfig,
			onClick: () => changeRoute(ROUTE_CONSTANTS.UNIT_CALENDAR),
		}, {
			id: 'manageUsers',
			label: 'Manage Users',
			icon: PeopleIcon,
			showForRoles: OfficeManagerRoles,
			onClick: () => changeRoute(ROUTE_CONSTANTS.MANAGE_USERS)
		}, {
			id: 'addUsers',
			label: 'Add Users',
			icon: PersonAdd,
			showForRoles: OfficeManagerRoles,
			onClick: () => changeRoute(ROUTE_CONSTANTS.USER_REGISTRATION),
		}, {
			id: 'logOut',
			label: 'Log out',
			icon: ExitToApp,
			onClick: logout,
		},
	], [changeRoute, hasPrefUnitsWithOpenTimeConfig, logout, setAnchorEl, ssmShowReleaseBlock20241205]);

	return {
		options,
		anchorEl,
		setAnchorEl,
	};
};

export default usePreferencesMenuConfig;
